import React, {useEffect, useState} from "react";
import {Stack, Typography} from "@mui/material";

import '../../css/App.css';
import HyperlinkText from "./HyperlinkText";
import {underscoredToTitleCase} from "../../helpers/TextUtils";
import {RECORDING_STATUS} from "../../domain/RecordingStatus";

export default function RecordingChip({ recordingStatus, recordingUrls, meetingLabel, options }) {

    const [recordingCount, setRecordingCount] = useState(0);
    const [recordingLabel, setRecordingLabel] = useState();

    useEffect(() => {

        if (recordingStatus === RECORDING_STATUS.COMPLETED_WITH_ISSUES && recordingUrls.length === 0) {
            setRecordingLabel('No Meeting Files Available');
        } else if (recordingStatus === RECORDING_STATUS.PENDING) {
            setRecordingLabel('Meeting Files Download Pending...');
        }

    }, [recordingStatus]);

    useEffect(() => {
        setRecordingCount(recordingUrls?.length);
    }, [recordingUrls]);

    const handleLinkClick = (url) => {
        fetch(url)
            .then((response) => response.blob())
            .catch((err) => console.log(err));
    }

    return (
        <Stack direction="column" justifyContent={"start"} sx={{padding: "0.45 rem"}}>
            {
              !options.displayMeetingId
              && <>
                  <Typography variant="subtitle2" color="white">{meetingLabel}</Typography>
                  <br/>
              </>
            }
            {
                recordingCount > 0
                && recordingUrls.map((eachRecordingUrl, index) => {

                    const recordingLabel = underscoredToTitleCase(eachRecordingUrl.recordingType);

                    return <HyperlinkText
                        label={recordingLabel}
                        url={eachRecordingUrl.recordingUrl}
                        key={index}
                        handleLinkClick={handleLinkClick}
                    />
                })
            }
            {
                recordingCount === 0
                && <Typography variant="subtitle2" color="white">{recordingLabel}</Typography>
            }
        </Stack>
    );
}
